import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeoLocationService {
  private apiUrl = 'https://ipwho.is/';

  constructor(private http: HttpClient) {}

  getGeolocation(): Observable<any> {
    return this.http.get(this.apiUrl);
  }
}
